export const GET_AFFILIATE_WITHDRAWALS = "GET_AFFILIATE_WITHDRAWALS";
export const APPROVE_AFFILIATE_WITHDRAWAL = "APPROVE_AFFILIATE_WITHDRAWAL";
export const REJECT_AFFILIATE_WITHDRAWAL = "REJECT_AFFILIATE_WITHDRAWAL";
export const GET_AFFILIATE_WITHDRAWAL_STATS = "GET_AFFILIATE_WITHDRAWAL_STATS";